import { Reveal } from "@/components/luxe/Reveal";

export const LuxeSectionHeader = ({ index, eyebrow, title, align = "left", className = "", light = false }) => (
  <Reveal className={`mb-10 sm:mb-14 ${align === "center" ? "text-center" : ""} ${className}`}>
    <div className={`flex items-center gap-4 ${align === "center" ? "justify-center" : ""}`}>
      {index && <span className="text-sm font-bold text-gold">{index}</span>}
      <span className="gold-rule w-10" aria-hidden="true" />
      <span className={`eyebrow ${light ? "text-[hsl(345_35%_80%)]" : "text-muted-foreground"}`}>{eyebrow}</span>
      {align === "center" && <span className="gold-rule w-10" aria-hidden="true" />}
    </div>
    {title && (
      <h2 className={`mt-5 font-display text-3xl leading-[1.05] sm:text-4xl sm:leading-[1.05] lg:text-5xl lg:leading-[1.05] ${light ? "text-[hsl(350_60%_97%)]" : "text-foreground"}`}>
        {title}
      </h2>
    )}
  </Reveal>
);
